export type CustomerAuthBootstrapResult<TVerifiedSession> =
  | ({ success: true } & TVerifiedSession)
  | { success: false; authFailure: boolean }

type ResolveCustomerAuthBootstrapOptions<TVerifiedSession> = {
  verify: () => Promise<CustomerAuthBootstrapResult<TVerifiedSession>>
  applyVerifiedSession: (session: TVerifiedSession) => void | Promise<void>
  handleAuthFailure: () => void | Promise<void>
  markResolved: () => void
}

export async function resolveCustomerAuthBootstrap<TVerifiedSession>({
  verify,
  applyVerifiedSession,
  handleAuthFailure,
  markResolved,
}: ResolveCustomerAuthBootstrapOptions<TVerifiedSession>): Promise<void> {
  try {
    const result = await verify()

    if (result.success) {
      await applyVerifiedSession(result)
    } else if (result.authFailure) {
      await handleAuthFailure()
    }
  } finally {
    markResolved()
  }
}
